import React from 'react'

const AVATAR_TINTS = [
  '#009ef7',
  '#7239ea',
  '#50cd89',
  '#f1416c',
  '#ffc700',
  '#3f4254',
]

const initialsOf = (name = '') =>
  name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase() || '?'

/** Deterministic tint so the same person keeps the same colour between renders. */
const tintFor = (seed = '') => {
  let hash = 0
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * 31 + seed.charCodeAt(i)) % 997
  }
  return AVATAR_TINTS[hash % AVATAR_TINTS.length]
}

export const Avatar = ({ name, src }) => (
  <span
    className='app-modal__avatar'
    style={src ? undefined : { background: tintFor(name || '') }}
  >
    {src ? <img src={src} alt='' /> : initialsOf(name)}
  </span>
)

/**
 * One choosable record. Used wherever the user picks a single item out of a
 * list — providers, staff, addresses — instead of a table row with an Assign
 * button per line, which hid the selection and needed horizontal scrolling.
 *
 * Renders as a <button> so keyboard and screen readers get selection for free.
 */
export const PickerRow = ({
  selected = false,
  onSelect,
  disabled = false,
  avatar,
  title,
  badges,
  meta,
  trailing,
}) => (
  <button
    type='button'
    className={`app-modal__pick-row ${selected ? 'app-modal__pick-row--on' : ''}`.trim()}
    aria-pressed={selected}
    disabled={disabled}
    onClick={onSelect}
  >
    <span className='app-modal__pick-radio' />
    {avatar}
    <span className='app-modal__pick-main'>
      <span className='app-modal__pick-title'>
        {title}
        {badges}
      </span>
      {meta && meta.length > 0 && (
        <span className='app-modal__pick-meta'>
          {meta.filter(Boolean).map((item, index) => (
            <span key={index}>{item}</span>
          ))}
        </span>
      )}
    </span>
    {trailing}
  </button>
)

/** `scroll` caps the list height so the footer stays in view on short screens. */
export const PickerList = ({ scroll = false, children }) => (
  <div className={`app-modal__pick ${scroll ? 'app-modal__pick--scroll' : ''}`.trim()}>
    {children}
  </div>
)

export default PickerRow
